const REPLY_EXPIRATION_INTERVAL = 24 * 60 * 60

const EMAIL_ADDRESS_REGEX = (/^[a-z0-9._+%-]+@[a-z0-9.-]+[.][a-z]+$/)
const PHONE_NUMBER_REGEX = /^\+?[0-9]{7,}/
const EMOJI_REGEX = new RegExp(
  '^[^' +
  '\u{1F600}-\u{1F64F}' + // Emoticons
  '\u{1F300}-\u{1F5FF}' + // Misc Symbols and Pictographs
  '\u{1F680}-\u{1F6FF}' + // Transport and Map Symbols
  '\u{1F1E0}-\u{1F1FF}' + // Regional Indicator Symbols
  '\u{2600}-\u{26FF}' + // Miscellaneous Symbols
  '\u{2700}-\u{27BF}' + // Dingbats
  ']*$',
  'u'
)

const CHAT_MESSAGE_TEMPLATE_TEXT_MAX_LENGTH = 1024

// Upper limit of combined size of files uploads. Temporary limit to prevent overloading
// the backend with files that will need
const COMBINED_ATTACHMENTS_MAX_SIZE = 50 * 1_048_576 // 50Mb

// 16MB, can be compressed to below 5Mb on backend
const WHATSAPP_BUSINESS_API_IMAGE_MAX_FILE_SIZE_BYTES = 16 * 1_048_576
const WHATSAPP_BUSINESS_API_DOCUMENT_MAX_FILE_SIZE_BYTES = 5 * 1_048_576 // 5Mb
const WHATSAPP_BUSINESS_API_VIDEO_MAX_FILE_SIZE_BYTES = 16 * 1_048_576 // 16Mb
const WHATSAPP_BUSINESS_API_AUDIO_MAX_FILE_SIZE_BYTES = 5 * 1_048_576 // 5Mb
// 32MB - for QuickTime videos with backend compression to 16MB
const QUICKTIME_VIDEO_MAX_FILE_SIZE_BYTES = 32 * 1_048_576

export {
  CHAT_MESSAGE_TEMPLATE_TEXT_MAX_LENGTH,
  COMBINED_ATTACHMENTS_MAX_SIZE,
  EMAIL_ADDRESS_REGEX,
  EMOJI_REGEX,
  PHONE_NUMBER_REGEX,
  QUICKTIME_VIDEO_MAX_FILE_SIZE_BYTES,
  REPLY_EXPIRATION_INTERVAL,
  WHATSAPP_BUSINESS_API_AUDIO_MAX_FILE_SIZE_BYTES,
  WHATSAPP_BUSINESS_API_DOCUMENT_MAX_FILE_SIZE_BYTES,
  WHATSAPP_BUSINESS_API_IMAGE_MAX_FILE_SIZE_BYTES,
  WHATSAPP_BUSINESS_API_VIDEO_MAX_FILE_SIZE_BYTES,
}
